export default "__VITE_PUBLIC_ASSET__ff5aa513__"